export const GET_SUGGESTIONS_REQUEST_SUCCESS = 'GET_SUGGESTIONS_REQUEST_SUCCESS';
export const GET_SUGGESTIONS_REQUEST_START = 'GET_SUGGESTIONS_REQUEST_START';
export const GET_SUGGESTIONS_REQUEST_FAILURE = 'GET_SUGGESTIONS_REQUEST_FAILURE';
export const CHANGE_PROPERTY_CODE_FILTER = 'CHANGE_PROPERTY_CODE_FILTER';
export const CHANGE_PROPERTY_LOCATION_FILTER = 'CHANGE_PROPERTY_LOCATION_FILTER';
export const CHANGE_PROPERTY_NAME_FILTER = 'CHANGE_PROPERTY_NAME_FILTER';
export const CHANGE_PROPERTY_NAME_FILTER_TEMP = 'CHANGE_PROPERTY_NAME_FILTER_TEMP';
export const CHANGE_PROPERTY_CLASSIFICATION_FILTER = 'CHANGE_PROPERTY_CLASSIFICATION_FILTER';
export const CHANGE_PROPERTY_CLASSIFICATION_FILTER_TEMP = 'CHANGE_PROPERTY_CLASSIFICATION_FILTER_TEMP';
export const CHANGE_PRICE_FILTER = 'CHANGE_PRICE_FILTER';
export const CHANGE_PRICE_FILTER_TEMP = 'CHANGE_PRICE_FILTER_TEMP';
export const CHANGE_STARS_FILTER = 'CHANGE_STARS_FILTER';
export const CHANGE_STARS_FILTER_TEMP = 'CHANGE_STARS_FILTER_TEMP';
export const CHANGE_MEALPLANS_FILTER = 'CHANGE_MEALPLANS_FILTER';
export const CHANGE_MEALPLANS_FILTER_TEMP = 'CHANGE_MEALPLANS_FILTER_TEMP';
export const CHANGE_PROPERTYTYPES_FILTER = 'CHANGE_PROPERTYTYPES_FILTER';
export const CHANGE_PROPERTYTYPES_FILTER_TEMP = 'CHANGE_PROPERTYTYPES_FILTER_TEMP';
export const CHANGE_COUNTRIES_FILTER = 'CHANGE_COUNTRIES_FILTER';
export const CHANGE_COUNTRIES_FILTER_TEMP = 'CHANGE_COUNTRIES_FILTER_TEMP';
export const CHANGE_CLASSIFICATION_FILTER = 'CHANGE_CLASSIFICATION_FILTER';
export const CHANGE_AWARDS_FILTER = 'CHANGE_AWARDS_FILTER';
export const SET_PROPERTIES_OFFERS_TRIGGERED_BY = 'SET_PROPERTIES_OFFERS_TRIGGERED_BY';
export const SET_PROPERTIES_PRICES_RANGE = 'SET_PROPERTIES_PRICES_RANGE';
export const RESET_PROPERTIES_FILTERS = 'RESET_PROPERTIES_FILTERS';
export const CHANGE_PROPERTY_COUNTRY_FILTER = 'CHANGE_PROPERTY_COUNTRY_FILTER';
export const RESET_AUTOCOMPLETE_FILTERS = 'RESET_AUTOCOMPLETE_FILTERS';
export const SET_AUTOCOMPLETE_FILTER = 'SET_AUTOCOMPLETE_FILTER';
export const SET_IS_FIRST_TIME = 'SET_IS_FIRST_TIME';
export const SET_ASSOCIATED_COUNTRIES = 'SET_ASSOCIATED_COUNTRIES';
export const SORT_PROPERTIES = 'SORT_PROPERTIES';
export const SET_CLASSIFICATIONS = 'SET_CLASSIFICATIONS';
export const APPLY_COUPON = 'APPLY_COUPON';
export const CHANGE_GOOGLE_MAPS_SESSION_TOKEN = 'CHANGE_GOOGLE_MAPS_SESSION_TOKEN';
export const SET_GEO_FILTERS = 'SET_GEO_FILTERS';
export const RESET_GEO_FILTERS = 'RESET_GEO_FILTERS';
export const PORTAL_FILTERS = 'PORTAL_FILTERS';
export const TOGGLE_ALTERNATIVE_OFFERS_SHOWN = 'TOGGLE_ALTERNATIVE_OFFERS_SHOWN';
